import { Descriptions } from "antd";
import { FC } from "react";
import { IStudent } from "../../../../models/students.model";
import { useTranslation } from "react-i18next";
import { EPaymentStep } from "../StudentPaymentPane";
import useUtil from "../../../../hooks/useUtil";

interface IProps {
  student?: IStudent;
  paymentStep: EPaymentStep;
};

const StudentInfoTable: FC<IProps> = ({
  student,
  paymentStep,
}) => {
  const { t } = useTranslation();
  const { getCommonCodeLabel } = useUtil();

  return (
    <div className='comm-table__area rowType'>
      <Descriptions
        column={paymentStep === EPaymentStep.PaymentCompleted ? 3 : 2}
        bordered
      >
        <Descriptions.Item label={`${t('student.student.column5')}(ID)`}>
          {student?.studentKorName}({student?.webId})
        </Descriptions.Item>
        {
          paymentStep === EPaymentStep.PaymentCompleted
            ? (
              <>
                <Descriptions.Item label={t('student.student.column2')}>
                  {student?.schoolName}
                </Descriptions.Item>
                <Descriptions.Item label={t('student.student.column3')}>
                  {getCommonCodeLabel('SY0006', student?.gradeCode)}
                </Descriptions.Item>
              </>
              )
            : (
              <Descriptions.Item label={t('student.student.column1')}>
                {student?.studentEngName}
              </Descriptions.Item>
              )
        }
      </Descriptions>
    </div>
  );
};

export default StudentInfoTable;